const init = () => {

	for (const btn of document.querySelectorAll('[data-spinner-btn]')) {

		btn.addEventListener('click', (e) => {
			btn.closest('form').submit()
			btn.disabled = true
			btn.classList.add('is-loading')
		})
	}
}

export default function() {
    init();
}